<template>
  <div class="entry-container">
    <sidebar-menu :menu="menu" collapsed hideToggle :disableHover="true"></sidebar-menu>
    <Loading v-if="item === undefined || entries === undefined" />
    <Error v-else-if="item === null" code="404"></Error>
    <router-view v-else :profile="profile" :user="user" :site="site" :entry="item" :entries="entries"/>
  </div>
</template>

<script>
import {db} from '@/main.js'
import ItemMixin from "@/mixins/Item.js"

export default {
  name: 'entry',
  mixins: [ItemMixin],
  props: ['user', 'profile', 'site'],
  firestore: function() {
    return {
      item: db.collection('site').doc(this.$route.params.site_id).collection(this.collection).doc(this.$route.params.id),
      entries: db.collection('site').doc(this.$route.params.site_id).collection(this.collection),
    }
  },
  computed: {
    menu: function() {
      let menu = []

      if (!this.item) {
        return menu
      }

      if (this.item.collection) {
        menu.push({href: {name: this.item.collection}, icon: 'fal fa-chevron-left'})
      }

      if (this.item && this.item.types.indexOf('page') > -1) {
        menu.push({href: {name: 'entry_page'}, icon: 'fad fa-window-maximize'})
      }

      menu.push({href: {name: 'entry_page_settings'}, icon: 'fad fa-cog'})

      return menu
    }
  },
  data() {
    return {
      entries: undefined,
      item: undefined,
      collection: 'entry'
    }
  },
}
</script>

<style>

.entry-container {
  padding-left: 50px;
}

</style>
